/* eslint-disable import/no-unresolved */
import { memo, useEffect } from "react";
import { FormikProps } from "formik";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomSelect from "../../../../../shared/CustomSelect";
import CustomHelperText from "../../../../../shared/CustomHelperText";
import {
  findKeysByValue,
  loanPageHelperText
} from "../../../../../helpers/FormDetails/ProposalDetails/resources";
import { LoanDetails } from "../../../../../helpers/FormDetails/ProposalDetails/interfaces";
import CustomTextField from "../../../../../shared/CustomTextField";

interface Props {
  formik: FormikProps<LoanDetails>;
}
function PremiumDetails({
  formik: { errors, setFieldTouched, touched, values, handleChange, handleBlur, setFieldValue }
}: Props) {
  const premiumMode = useAppSelector((state) => state.masterdata_reducer?.mode) || {};
  const isProportionateLead = useAppSelector((state) => state.common?.isProportionateLead);
  const { planDetails: { premiumDetails, totalPayment } = {} as any } =
    useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema) || {};
  useEffect(() => {
    setFieldValue(
      "premiumDetails.premiumModeCode",
      findKeysByValue(premiumMode, values.premiumDetails?.premiumMode) || ""
    );
  }, [values.premiumDetails?.premiumMode]);
  return (
    <div>
      <span className="font-montserrat text-black text-base font-bold mt-8 mb-6 flex">
        Premium Details
      </span>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-10 gap-y-6">
        {premiumDetails?.visible && (
          <CustomSelect
            requiredStar={premiumDetails?.required}
            disabledField={premiumDetails?.disabled || isProportionateLead}
            label={premiumDetails?.label}
            options={Object.values(premiumMode)}
            onChange={handleChange}
            setFieldTouched={setFieldTouched}
            name="premiumDetails.premiumMode"
            value={values.premiumDetails.premiumMode}
            error={errors.premiumDetails?.premiumMode}
            touched={touched.premiumDetails?.premiumMode}
          />
        )}
        {totalPayment?.visible && (
          <div>
            <CustomTextField
              requiredStar={totalPayment?.required}
              disabledField={totalPayment?.disabled}
              label={totalPayment?.label}
              onChange={() => {}}
              handleBlur={handleBlur}
              name="premiumDetails.totalPayment"
              value={Number(values.premiumDetails?.totalPayment).toLocaleString("en-IN")}
              error={errors.premiumDetails?.totalPayment}
              touched={touched.premiumDetails?.totalPayment}
            />
            <CustomHelperText>{loanPageHelperText.totalPayment}</CustomHelperText>
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(PremiumDetails);
